<template>
  <div class="slider-container grid-x align-justify">
    <hr class="custom-divider" />
    <div v-for="option in options" :key="option.value" class="input-wrapper grid-y align-middle">
      <label :for="option.id || option.value">
        <input
          :id="option.id || option.value"
          :name
          type="radio"
          :value="option.value"
          :aria-label="option.label"
          :aria-describedby="'scale-' + option.id"
          :checked="modelValue === option.value"
          @click="onSelect(option)"
        />
        <span class="input-label">
          {{ option.label }}
        </span>
      </label>
    </div>
  </div>
</template>
<script setup>
const modelValue = defineModel({ type: String, default: '' });

defineProps({
  name: {
    type: String,
    default: 'scale',
  },
  options: {
    /** @type import('vue').PropType<Array<{id: string, value: string, label: string}>> */
    type: Array,
    default: () => [],
  },
});

const onSelect = (option) => {
  if (modelValue.value === option.value) return;
  modelValue.value = option.value;
};
</script>
<style lang="scss" scoped>
@import '~@core/csg/src/scss/forms/forms.scss';
@include csg-forms;

.slider-container {
  width: rem-calc(400); /* Width of the outside container */
  position: relative;

  @include breakpoint(small only) {
    width: rem-calc(335);
  }
}

.input-wrapper {
  width: rem-calc(80);

  input[type='radio'] {
    margin: 0 0 rem-calc(6) 0;
  }

  .input-label {
    text-align: center;
    font-size: $font-size-sm;
    line-height: $line-height-sm; /* Line Height - MCOM 18px, BCOM 16px */
    color: $black;
  }
  label {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
  }
}

.custom-divider {
  position: absolute;
  top: rem-calc(10);
  left: 0;
  right: 0;
  margin: 0 auto;
  width: calc(100% - 60px);
  border: 2px solid $gray-5-color;
}
</style>
